interface ChallengeHeaderProps {
  children: React.ReactNode
}

export default function ChallengeHeader({ children }: ChallengeHeaderProps) {
  return <div className="flex h-fit w-full">{children}</div>
}
